export const HX_COLORS = {
  blue: "#2563EB",
  green: "#059669",
  violet: "#7C3AED",
  orange: "#EA580C",
  red: "#DC2626",
};
